import TEXT, { HTMLELEMENT } from '../../DOM/text/TEXT.js';
import SPAN from '../../DOM/span/SPAN.js';
export default class CITE extends TEXT {
    constructor(node, model) {
        super(node, HTMLELEMENT.CITE, model);
    }
    addSpan(model) {
        return this.addChild(new SPAN(this, model));
    }
}
